import { BellSimple } from '@phosphor-icons/react';
import '../../../../css/logo.less';
import '../../../../css/tab-header-dropdown.less';
import '../../../../css/transitions.less';
import boomiLogo from '../../../../img/AtomSphere-Logo.svg';
import translations from '../../translations';
import { useAuth } from '../AuthProvider';
import SSOExpiryNotification from '../notifications/SSOExpiryNotification';
import HeaderNav from './HeaderNav';
import RegionSwitcher from './RegionSwitcher';
import UserSettingsButton from './UserSettingsButton';
import type { UserTenantResponseAPI } from '../../types/user';

interface HeaderProps {
    openTenantSelector: () => void;
    tenant: UserTenantResponseAPI | null;
}

const Header = ({ openTenantSelector, tenant }: HeaderProps) => {
    const { signOutUser } = useAuth();

    const onLogoutClick = () => {
        signOutUser();
    };

    return (
        <div className="tab-header">
            <div className="logo">
                <img src={boomiLogo} alt="Boomi AtomSphere" />
            </div>
            {tenant && <HeaderNav openTenantSelector={openTenantSelector} tenant={tenant} />}
            <nav className="tab-header-admin header-admin-right">
                {tenant && !tenant.isSso && <RegionSwitcher />}
                {/* SSO users shouldn't be able to see the user settings button for now,
                because it adds confusion and doesn't function fully as expected */}
                {tenant && !tenant.isSso && <UserSettingsButton />}
                {/* Pendo is set up to open the Flow Resource Centre when the following is clicked */}
                <div className="dropdown-box" id="pendo-resource-centre">
                    <button className="dropdown-btn" type="button">
                        <BellSimple width="25" height="25" />
                    </button>
                </div>
                <div className="logout">
                    <button className="logout-btn" onClick={onLogoutClick} type="button">
                        {translations.HEADER_sign_out}
                    </button>
                </div>
            </nav>
            <SSOExpiryNotification />
        </div>
    );
};

export default Header;
